import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { REMOVE_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Also used read-only (no onRemove) by ServiceHistoryRow to render saved thumbnails.
const ServicePhotoThumb: FunctionComponent<Props> = ({
    className = '',
    onRemove,
    photo,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    const handleRemove = () => onRemove?.({ photoId: photo.id });

    return (
        <VerticalContainer className={`${styles.servicePhotoThumb} ${className}`} testId={testId}>
            <img alt={photo.fileName} className={styles.image} src={photo.url} />

            {onRemove && (
                <Wrapper
                    className={styles.removeAction}
                    onClick={handleRemove}
                    testId={REMOVE_TEST_ID}>
                    {t.LOG_SERVICE_PHOTO_REMOVE}
                </Wrapper>
            )}
        </VerticalContainer>
    );
};

export default ServicePhotoThumb;
